/**
 * Component gốc ứng dụng React.
 *
 * Cấu trúc provider:
 * - BrowserRouter: routing client-side.
 * - ScrollToTop: cuộn lên đầu khi đổi route.
 * - AuthDialogProvider: quản lý dialog đăng nhập/đăng ký toàn cục.
 * - AppRoutes: định nghĩa toàn bộ route và layout.
 */
import { BrowserRouter } from 'react-router-dom';
import { ScrollToTop } from './components/Common/ScrollToTop';
import { AuthDialogProvider } from './context/AuthDialogContext';
import { AppRoutes } from './routes/AppRoutes';
import './styles/globals.css';
import './styles/layout.css';
import './styles/home.css';
import './styles/property-detail.css';
import './styles/dialogs.css';
import './styles/forms.css';
import './styles/admin.css';

/** Root component — bọc router và global providers */
function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AuthDialogProvider>
        <AppRoutes />
      </AuthDialogProvider>
    </BrowserRouter>
  );
}

export default App;
